<template>
  <div>
    <vxe-toolbar>
      <template #buttons>
        <vxe-button status="primary" icon="fa fa-plus" @click="insertEvent()">新增</vxe-button>
      </template>
    </vxe-toolbar>
    <vxe-table border resizable show-overflow highlight-hover-row ref="xTable" height="500" :data="tableData" @cell-dblclick="cellDBLClickEvent">
      <vxe-column type="seq" width="60" title="序号"></vxe-column>
      <vxe-column field="remark" title="摘要" width="400"></vxe-column>
      <vxe-column field="dataSource" title="科目来源" width="100" :formatter="formatterDataSource"></vxe-column>
      <vxe-column field="costId" title="会计科目" width="100">
        <template #default="{ row, rowIndex }">
          {{ formatterCostName(row.costId) }}
        </template>
      </vxe-column>
      <vxe-column field="isBorrow" title="借贷方" width="100" :formatter="formatterBorrow"></vxe-column>
      <vxe-column field="amountField" title="金额字段" width="200">
        <template #default="{ row, rowIndex }">
          {{ formatteramountField(row.amountField) }}
        </template>
      </vxe-column>
      <vxe-column field="isLetter" title="是否红字" width="100" :formatter="formatterIs"></vxe-column>
      <vxe-column field="isDefault" title="是否默认" width="100" :formatter="formatterIs"></vxe-column>
      <vxe-column field="scopeOfAccounting" v-if="taxNo != 'k3'" title="核算范围" width="200" :formatter="formatterScopeOfAccounting"></vxe-column>
      <vxe-column title="操作" width="150" show-overflow>
        <template #default="{ row, rowIndex }">
          <vxe-button type="text" @click="editEvent(row, rowIndex)">编辑</vxe-button>
          <vxe-button type="text" @click="removeEvent(row)">删除</vxe-button>
        </template>
      </vxe-column>
    </vxe-table>

    <vxe-modal
      v-model="showEdit"
      :title="selectRow ? '编辑&保存' : '新增&保存'"
      width="50%"
      min-width="600"
      min-height="600"
      :loading="submitLoading"
      resize
      destroy-on-close
    >
      <template #default>
        <vxe-form ref="xForm" :data="formData" :rules="formRules" title-align="right" title-width="100" @submit="submitEvent">
          <vxe-form-item title="摘要" field="remark" span="20" :item-render="{}">
            <template #default="params">
              <vxe-textarea
                v-model="params.data.remark"
                placeholder="请输入摘要"
                :autosize="{ minRows: 6, maxRows: 8 }"
                clearable
                @input="$refs.xForm.updateStatus(params)"
              ></vxe-textarea>
            </template>
          </vxe-form-item>
          <vxe-form-item span="4">
            <template #default="params">
              <evo-bo-var-selector :boKey="boKey" @input="boVarSelect(params, ...arguments)"></evo-bo-var-selector>
            </template>
          </vxe-form-item>
          <vxe-form-item title="科目来源" field="dataSource" span="12" :item-render="{}" title-overflow>
            <template #default="params">
              <vxe-select
                v-model="params.data.dataSource"
                placeholder="请选择科目来源"
                :options="dataSourceList"
                :option-props="{ value: 'id', label: 'desc' }"
                clearable
                transfer
                @change="dataSourceSelect(params, ...arguments)"
              >
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="会计科目" field="costId" span="12" :item-render="{}" title-overflow>
            <template #default="params">
              <eco-select
                v-model="params.data.costId"
                placeholder="请选择会计科目"
                style="width: 100%"
                :options="costList"
                :props="{ key: 'id', value: 'name' }"
                clearable
                transfer
                filterable
                :disabled="costDisabled"
                @change="costSelect(params, ...arguments)"
              >
              </eco-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="借贷方" field="isBorrow" span="12" :item-render="{}" title-overflow>
            <template #default="params">
              <vxe-radio name="isBorrow" v-model="params.data.isBorrow" :label="0" content="借方"></vxe-radio>
              <vxe-radio name="isBorrow" v-model="params.data.isBorrow" :label="1" content="贷方"></vxe-radio>
            </template>
          </vxe-form-item>
          <vxe-form-item title="金额字段" field="amountField" span="12" :item-render="{}" title-overflow>
            <template #default="params">
              <vxe-select
                v-model="params.data.amountField"
                placeholder="请选择金额字段"
                :options="amountFieldList"
                :option-props="{ value: 'id', label: 'desc' }"
                clearable
                transfer
                @change="costSelect(params, ...arguments)"
              >
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="是否红字" field="isLetter" span="12" :item-render="{}" title-overflow>
            <template #default="params">
              <vxe-radio name="isLetter" v-model="params.data.isLetter" :label="0" content="否"></vxe-radio>
              <vxe-radio name="isLetter" v-model="params.data.isLetter" :label="1" content="是"></vxe-radio>
            </template>
          </vxe-form-item>
          <vxe-form-item title="是否默认" field="isDefault" span="12" :item-render="{}" title-overflow>
            <template #default="params">
              <vxe-radio name="isDefault" v-model="params.data.isDefault" :label="0" content="否"></vxe-radio>
              <vxe-radio name="isDefault" v-model="params.data.isDefault" :label="1" content="是"></vxe-radio>
            </template>
          </vxe-form-item>
          <vxe-form-item v-if="taxNo != 'k3'" title="核算项目范围" field="scopeOfAccounting" span="24" :item-render="{}" title-overflow>
            <template #default="params">
              <el-select
                style="width: 100%"
                v-model="params.data.scopeOfAccounting"
                placeholder="请选择核算范围"
                clearable
                multiple
                @change="costSelect(params, ...arguments)"
              >
                <el-option v-for="item in financeTypeGroupList" :key="item.id" :label="item.desc" :value="item.id"> </el-option>
              </el-select>
            </template>
          </vxe-form-item>
          <vxe-form-item align="center" span="24" :item-render="{}">
            <template #default>
              <vxe-button type="submit" status="primary">保存</vxe-button>
              <vxe-button type="reset">重置</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import req from '@/request.js'
import portalApi from '@/api/portal'
const evoBoVarSelector = () => import('@/components/selector/EvoBoVarSelector.vue')
export default {
  components: {
    evoBoVarSelector
  },
  props: {
    taxNo: String,
    boKey: String,
    corporateId: String,
    modelName: Object,
    tableData: {
      type: Array,
      default: () => []
    },
    dataSourceList: {
      type: Array,
      default: () => []
    },
    financeTypeGroupList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      costList: [],
      amountFieldList: [],
      submitLoading: false,
      selectRow: null,
      showEdit: false,
      costDisabled: false,
      formData: {
        remark: null,
        dataSource: null,
        costName: null,
        costId: null,
        costAlias: null,
        isBorrow: null,
        scopeOfAccounting: null
      },
      formRules: {
        remark: [{ required: true, message: '请输入摘要' }],
        dataSource: [{ required: true, message: '请输入科目来源' }],
        isBorrow: [{ required: true, message: '请选择借贷方' }],
        amountField: [{ required: true, message: '请选择金额字段' }],
        isDefault: [{ required: true, message: '请选择是否默认' }],
        isLetter: [{ required: true, message: '请选择是否红字' }]
      }
    }
  },
  mounted() {
    this.getNcAccount()
    req.get('${third}/third_document_template/getAmountFieldByType?type=' + this.modelName.name).then((response) => {
      this.amountFieldList = response.data
    })
  },
  created() {},
  methods: {
    formatterDataSource({ cellValue }) {
      let item = this.dataSourceList.find((item) => item.id === cellValue)
      return item ? item.desc : ''
    },
    formatterCostName(value) {
      let item = this.costList.find((item) => item.id === value)
      return item ? item.name : ''
    },
    formatterBorrow({ cellValue }) {
      switch (cellValue) {
        case 1:
          return '贷方'
        case 0:
          return '借方'
        default:
          return cellValue
      }
    },
    //是否
    formatterIs({ cellValue }) {
      switch (cellValue) {
        case 0:
          return '否'
        case 1:
          return '是'
        default:
          return cellValue
      }
    },
    getNcAccount() {
      this.costList = []
      let params = {
        corporateId: this.corporateId,
        id: 0
      }
      portalApi.getCostAccountById(params).then((response) => {
        this.costList = response
      })
    },
    // 金额字段
    formatteramountField(cellValue) {
      let item = this.amountFieldList.find((item) => item.id === cellValue)
      return item ? item.name : cellValue
    },
    // 核算范围字段
    formatterScopeOfAccounting({ cellValue }) {
      let item = ''
      if (cellValue) {
        let arr = Array.isArray(cellValue) ? cellValue : cellValue.split(',')
        arr.forEach((p) => {
          let result = this.financeTypeGroupList.find((i) => i.id == p)
          if (result) {
            item += result['desc'] + ','
          }
        })
        item = item.slice(0, item.length - 1)
      }
      return item ? item : cellValue
    },
    cellDBLClickEvent({ row }) {
      this.editEvent(row)
    },
    insertEvent() {
      if (!this.corporateId) {
        this.$message.info('请选择法人机构！')
        return
      }
      if (!this.boKey) {
        this.$message.info('请选择凭证类型！')
        return
      }
      this.formData = {
        remark: '',
        dataSource: '',
        costName: '',
        costId: '',
        costAlias: '',
        isBorrow: 0,
        amountField: '',
        isDefault: 0,
        isLetter: 0,
        scopeOfAccounting: ''
      }
      this.selectRow = null
      this.showEdit = true
    },
    editEvent(row, index) {
      this.checkDisable(row.dataSource)
      this.formData = {
        index: index,
        remark: row.remark,
        dataSource: row.dataSource,
        costName: row.costName,
        costId: row.costId,
        costAlias: row.costAlias,
        isBorrow: row.isBorrow,
        isLetter: row.isLetter,
        isDefault: row.isDefault,
        amountField: row.amountField,
        scopeOfAccounting: row.scopeOfAccounting
      }
      this.selectRow = row
      this.showEdit = true
    },
    removeEvent(row) {
      this.$confirm('您确定要删除该数据?').then((type) => {
        if (type === 'confirm') {
          this.$refs.xTable.remove(row)
          this.$emit('dataChange', this.$refs.xTable.getTableData().fullData)
        }
      })
    },
    submitEvent() {
      this.submitLoading = true
      setTimeout(() => {
        this.submitLoading = false
        this.showEdit = false
        if (this.selectRow) {
          this.isDefaultChange(this.formData, 'update')
          this.$message.success('更新成功')
          Object.assign(this.selectRow, this.formData)
        } else {
          this.isDefaultChange(this.formData, 'create')
          this.$message.success('新增成功')
          this.$refs.xTable.insertAt(this.formData, -1)
        }
        this.$emit('dataChange', this.$refs.xTable.getTableData().fullData)
      }, 100)
    },
    boVarSelect(...arg) {
      if (arg[0].data.remark) {
        arg[0].data.remark = arg[0].data.remark + arg[1]
      } else {
        arg[0].data.remark = arg[1]
      }
    },
    dataSourceSelect(...arg) {
      this.$refs.xForm.updateStatus(arg[0])
      // 手工 可手动选科目
      if (arg[1].value == '1' || arg[1].value == '5' || arg[1].value == '6') {
        this.costDisabled = false
      } else {
        this.costDisabled = true
        arg[0].data.costId = ''
        arg[0].data.costName = ''
        arg[0].data.costAlias = ''
      }
    },
    checkDisable(item) {
      // 手工 可手动选科目
      if (item == '1' || item == '5' || item == '6') {
        this.costDisabled = false
      } else {
        this.costDisabled = true
      }
    },
    isDefaultChange(formVal, state) {
      if (this.modelName) {
        if (this.modelName.sub_third_document_template_detail) {
          this.modelName.sub_third_document_template_detail.forEach((value, index) => {
            if (state == 'create') {
              if (formVal.isDefault) {
                if (value.isBorrow == formVal.isBorrow) {
                  value.isDefault = 0
                }
              }
            }
            if (state == 'update') {
              if (formVal.isDefault && value.isBorrow == formVal.isBorrow) {
                if (formVal.index != index) {
                  value.isDefault = 0
                }
              }
            }
          })
        }
      }
    },
    costSelect(...arg) {
      this.$refs.xForm.updateStatus(arg[0])
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.vxe-select--panel {
  z-index: 9997 !important;
}
.is--visible {
  z-index: 2222 !important;
}
.vxe-table--empty-placeholder {
  top: 50px !important;
}
</style>
